import { not } from 'ramda'
import { useCallback, useState } from 'react'

import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
import PlainConfirmModal from 'app/common/ui-next/plain-confirm-modal'

import styles from './DietFoodItem.module.scss'
import PlainLabel from 'app/common/ui-next/plain-label'
import { DietFoodTypeId, DietFoodType } from 'app/dataTypes/org/dietFoodTypes'


type Props = {
  item?: DietFoodType
  disabled?: boolean
  onDelete: (id: DietFoodTypeId) => Promise<boolean>
}

export const DietFoodItem = ({ item, onDelete, disabled }: Props) => {
  const { id, title } = item || {}

  const [pending, setPending] = useState(false)

  const [confirm, setConfirm] = useState(false)
  const toggleConfirm = useCallback(() => {
    setConfirm(not)
  }, [])

  const handleDelete = useCallback(async () => {
    if (!id) return
    setPending(true)
    const res = await onDelete(id)
    setPending(false)
    if (res) {
      setConfirm(not)
    }
  }, [onDelete, id])


  return (
    <div className={styles.root}>
      <PlainLabel
        id='dietFoodLabel'
        className={styles.title}
      >
        {title}
      </PlainLabel>
      {confirm
        && <PlainConfirmModal
          messageText={`Удалить диетическое питание «${title}»?`}
          onCancel={toggleConfirm}
          onConfirm={handleDelete}
          confirmButtonProps={{ disabled: pending }}
          cancelButtonProps={{ disabled: pending }}
          confirmButtonTitle={pending ? 'Удаление...' : 'Удалить'}
          critical
        />}
      <PlainButtonAsLink
        className={styles.link}
        onClick={toggleConfirm}
        disabled={disabled}
      >
        {'Удалить диетическое питание'}
      </PlainButtonAsLink>
    </div>
  )
}
